import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';
import Utility from '../../utils/Utilty';

/** テーブル */
const TableComponent = ({ tableData, countDecimalPlaces = 1, maxRows = 16 }) => {

    // 小数点以下の桁数を丸める関数
    const formatCount = (value) => value.toFixed(countDecimalPlaces);
    const borderLine = `1px solid black`;
    const fonts = '"ヒラギノ明朝 ProN", "Hiragino Mincho ProN", "Yu Mincho", "游明朝", "MS PMincho", "MS Mincho", serif';

    const dynamicStyle = {
        border: borderLine,
        fontWeight: 'normal',
        width: 'auto', // 動的幅
        padding: '2px 8px', // 上下の余白: 2px、左右の余白: 8px
        fontFamily: fonts,
    };

    const fixedStyle = {
        border: borderLine,
        fontWeight: 'normal',
        width: '60px', // 固定幅
        padding: '2px 1px', // 上下の余白: 2px、左右の余白: 8px
        textAlign: 'center',
        fontFamily: fonts,
    };

    // 行データを制限し、空白行を追加
    const limitedData = tableData.slice(0, maxRows); // 最大行数だけ取得
    const emptyRows = maxRows - limitedData.length; // 空白行の数を計算

    return (
        <TableContainer
            component={Paper}
            style={{
                margin: '0px',
                boxShadow: 'none', // 影を削除
                border: 'none', // 外枠の罫線
                borderRadius: 0,
                zIndex: 1000,
            }}
        >
            <Table
                style={{
                    borderCollapse: 'collapse', // 罫線を連続させる
                    border: borderLine, // テーブル全体の罫線
                    width: '100%',
                }}
            >
                {/* テーブルヘッダー */}
                <TableHead>
                    <TableRow>
                        <TableCell rowSpan={2} align="center" style={dynamicStyle}>
                            <span style={{ paddingRight: '40px', paddingLeft: '40px' }}>種　　　　　　　名</span>
                        </TableCell>
                        <TableCell colSpan={5} align="center" style={fixedStyle}>個体数</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align="center" style={fixedStyle}>総個数</TableCell>
                        <TableCell align="center" style={fixedStyle}>平均値</TableCell>
                        <TableCell align="center" style={fixedStyle}>中央値</TableCell>
                        <TableCell align="center" style={fixedStyle}>分散</TableCell>
                        <TableCell align="center" style={fixedStyle}>標準偏差</TableCell>
                    </TableRow>
                </TableHead>

                {/* テーブルボディ */}
                <TableBody>
                    {/* データ行 */}
                    {limitedData.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell style={dynamicStyle}>{row.route_name}</TableCell>
                            <TableCell align="center" style={fixedStyle}>{Math.round(Utility.sum(row.counts)*10)/10}</TableCell>
                            <TableCell align="center" style={fixedStyle}>{Math.round(Utility.mean(row.counts)*10)/10}</TableCell>
                            <TableCell align="center" style={fixedStyle}>{Math.round(Utility.median(row.counts)*10)/10}</TableCell>
                            <TableCell align="center" style={fixedStyle}>{Math.round(Utility.variance(row.counts)*10)/10}</TableCell>
                            <TableCell align="center" style={fixedStyle}>{Math.round(Utility.standardDeviation(row.counts)*10)/10}</TableCell>
                        </TableRow>
                    ))}
                    {/* 空白行 */}
                    {[...Array(emptyRows)].map((_, index) => (
                        <TableRow key={`empty-${index}`}>
                            <TableCell style={dynamicStyle}>&nbsp;</TableCell>
                            <TableCell align="center" style={fixedStyle}>&nbsp;</TableCell>
                            <TableCell align="center" style={fixedStyle}>&nbsp;</TableCell>
                            <TableCell align="center" style={fixedStyle}>&nbsp;</TableCell>
                            <TableCell align="center" style={fixedStyle}>&nbsp;</TableCell>
                            <TableCell align="center" style={fixedStyle}>&nbsp;</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default TableComponent;
